var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.categories.length > 0
    ? _c(
        "ul",
        { class: _vm.ul_class },
        _vm._l(_vm.categories, function (category) {
          return _c(
            "li",
            { class: { show_children: category.children_show } },
            [
              _c(
                "a",
                {
                  staticClass: "waves-effect waves-themed",
                  class: { active_filter: _vm.is_active_categ(category) },
                  attrs: { href: "javascript:void(0);" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  category.published
                    ? _c(
                        "strong",
                        {
                          staticClass: "dl-ref bg-success-500 hidden-sm-down",
                          on: {
                            click: function ($event) {
                              if ($event.target !== $event.currentTarget) {
                                return null
                              }
                              return _vm.setActive(category)
                            },
                          },
                        },
                        [_vm._v("active")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !category.published
                    ? _c(
                        "strong",
                        {
                          staticClass: "dl-ref bg-danger-500",
                          on: {
                            click: function ($event) {
                              if ($event.target !== $event.currentTarget) {
                                return null
                              }
                              return _vm.setActive(category)
                            },
                          },
                        },
                        [_vm._v("active")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "nav-link-text color-black",
                      class: { "text-muted": !category.published },
                      on: {
                        click: function ($event) {
                          if ($event.target !== $event.currentTarget) {
                            return null
                          }
                          return _vm.setActive(category)
                        },
                      },
                    },
                    [
                      _c("div", [
                        _c("div", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(category.title) +
                              "\n                        "
                          ),
                          _c("span", { staticClass: "small text-info" }, [
                            category.skeep_sync
                              ? _c("i", { staticClass: "fal fa-lock" })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "small text-info" }, [
                            category.category_mode == "tag"
                              ? _c("i", { staticClass: "fal fa-hashtag" })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          category.adv_name.length > 0
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "small badge border border-primary text-primary",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(category.adv_name) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  category.children.length > 0 && _vm.depth == 0
                    ? _c("b", { staticClass: "collapse-sign color-black" }, [
                        _c("em", {
                          staticClass:
                            "fal fa-angle-down color-black children_info",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.show_children(category)
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fal fa-cog width-2 fs-xxl ml-4",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.edit(category)
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              category.children.length > 0
                ? _c("categ_sub", {
                    attrs: { depth: 1, categories: category.children },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }